import styled, { css } from "styled-components";

export const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FlexColumnContainerWithJustifyCenter = styled(FlexColumnContainer)`
  justify-content: center;
`;

export const FlexRowContainerWithJustifyCenter = styled(FlexRowContainer)`
  justify-content: center;
`;

export const HiddenItem = styled.div`
  display: none;
`;

export const FlexRowWrapContainer = styled(FlexRowContainer)`
  flex-wrap: wrap;
`;

export const FlexRowNoWrapContainer = styled(FlexRowContainer)`
  flex-flow: row nowrap;
`;

export const VerticalDivider = styled.div`
  display: block;
  width: 1px;
  margin: 0 6px;
  background-color: #797979;
`;

export const StrongBoldCss = css`
  & strong,
  b {
    font-weight: bold;
  }
`;

export const StrongText = styled.strong`
  font-weight: bold;
`;
